/* this file added by Bearer Web Developer  */
import { firebaseApp } from "../../../api/bearer-api";
import { error } from "../../../app/log";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { TRegisterBusinessCustomerEditEmailResponse } from "../models/registerBusinessCustomerEditEmail";

const registerBusinessCustomerEditEmail = async (email_address: string): Promise<TRegisterBusinessCustomerEditEmailResponse | void> => { // void type added by Bearer Web Developer
    try {
        // add the location string as you call getFunctions
        const functions = getFunctions(firebaseApp, 'australia-southeast2');
        const t = httpsCallable<{ email_address: string }, TRegisterBusinessCustomerEditEmailResponse>(functions, 'registerBusinessCustomerEditEmail');
        const result = await t({ email_address });
        return result.data;
    } catch (err: any) {
        error(err); // modify by Bearer Web Developer
        error(err?.message || 'unknown error');   // throw new Error modified by Bearer Web Developer 
    }
}
export default registerBusinessCustomerEditEmail;